import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { persistQueryClient } from "@tanstack/query-persist-client-core";
import { QueryKeys } from "./querys/querys.enum";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      retryOnMount: false,
      gcTime: 1000 * 60 * 60 * 1, // 1 hours
      staleTime: 1000 * 60 * 60 * 1, // 1 hours
    },
  },
});
const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: "queryClient",
});

persistQueryClient({
  queryClient: queryClient as any,
  persister: localStoragePersister,
  dehydrateOptions: {
    shouldDehydrateQuery: ({ queryKey, state }) => {
      if (queryKey[0] === QueryKeys.USER) {
        return true;
      } else {
        return false;
      }
    },
  },
});

export { queryClient };
